import type { BanterLine, TeacherContent } from '../types.ts';
import banterJson from './banter.json' with { type: 'json' };
import baselineJson from './baseline.json' with { type: 'json' };
import formulasJson from './formulas.json' with { type: 'json' };
import grammarNotesJson from './grammarNotes.json' with { type: 'json' };
import voiceJson from './voice.config.json' with { type: 'json' };
import teacherJson from './teacher.json' with { type: 'json' };
import a1Json from './levels/a1.json' with { type: 'json' };
import pilotJson from './levels/pilot.json' with { type: 'json' };

export const banter = banterJson as BanterLine[];
export const baseline: string[] = baselineJson.words;
export const formulas = formulasJson.formulas as Array<{ en: string; pl: string; level: 'A1' | 'A2' | 'B1' | 'B2' | 'C1' | 'C2' }>;
export const grammarNotes = grammarNotesJson.notes as unknown as Record<string, import('../lib/grammarNotes.ts').GrammarNote>;
export const voiceConfig = voiceJson;
export const teacherContent = teacherJson as TeacherContent;
/**
 * Lekcje kursu v2 dostarczane z aplikacją, w kolejności: lekcje 1–5 (`levels/a1.json`), potem 6–11 (`levels/pilot.json` — od patch-43 pełnoprawne lekcje kursu,
 * nie osobny pilotaż: A1 ×3, A2, B1, B2; SPEC §23.24). Ich id zostają (a1-901…), bo pod nimi są nagrania i obrazki.
 */
export const courseLessons = [...(a1Json as unknown as import('../lib/levels.ts').LessonsFile).lessons, ...(pilotJson as unknown as import('../lib/levels.ts').LessonsFile).lessons];
